import React from "react";

export default function Forbidden() {
  return (
    <div>
      <h1>Forbidden</h1>
      <h3>Sorry !</h3>
      <p>No such page or you do not have permisson for this page.</p>
    </div>
  );
}
